import { useEffect, useState } from "react";
import axios from "axios";
import { Hand, Gem, Layers, Brush, Sparkles, Flower2, CalendarDays } from "lucide-react";
import { API } from "@/config";

const ICONS = [Hand, Gem, Layers, Sparkles, Brush, Flower2];

const FALLBACK = [
  { name: "Manicura Rusa", desc: "Cutículas impecables con técnica de torno y un acabado pulido que luce por semanas.", price: "25€" },
  { name: "Soft Gel", desc: "Uñas de aspecto natural, flexibles y con un brillo espejo que enamora.", price: "35€" },
  { name: "Acrílico Esculpido", desc: "Largo y forma a tu medida: almond, coffin, square o la tendencia que sueñes.", price: "45€" },
  { name: "Nivelación Rubber Base", desc: "Fuerza y estructura para que tus uñas naturales crezcan sanas y hermosas.", price: "30€" },
  { name: "Nail Art de Autor", desc: "Diseños pintados a mano alzada: French, aura, florales o lo que imagines. Únicos, como tú.", price: "desde 10€" },
  { name: "Pedicura Spa", desc: "Cuidado completo, exfoliación y relax para unos pies dignos de playa caribeña.", price: "30€" },
];

export default function Services({ onBook }) {
  const [services, setServices] = useState(FALLBACK);

  useEffect(() => {
    axios
      .get(`${API}/services`)
      .then((res) => {
        if (res.data.length) setServices(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="servicios" data-testid="services-section" className="py-16 sm:py-24 lg:py-32 bg-creamcard">
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <p className="text-xs sm:text-sm tracking-[0.3em] uppercase text-gold font-medium">01 · Servicios</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-obsidian mt-4">
            Cuidado experto para cada estilo de uña
          </h2>
          <p className="text-sm sm:text-base text-taupe mt-4 leading-relaxed">
            Trabajo con productos premium y esterilización de grado clínico.
            Elige tu servicio, reserva tu día y del resto me encargo yo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {services.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={s.id || s.name}
                data-testid={`service-card-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group rounded-2xl bg-cream border border-sand p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-gold/10 hover:border-gold/40"
              >
                <div className="w-12 h-12 rounded-full bg-rosesoft flex items-center justify-center transition-colors duration-300 group-hover:bg-gold/15">
                  <Icon className="w-5 h-5 text-gold" />
                </div>
                <h3 className="font-display text-xl sm:text-2xl font-semibold text-obsidian mt-5">{s.name}</h3>
                <p className="text-sm text-taupe leading-relaxed mt-3">{s.desc}</p>
                <div className="mt-5 flex items-center justify-between gap-3">
                  <p className="flex items-baseline gap-2">
                    <span className="font-display text-2xl font-semibold text-gold">{s.price}</span>
                    <span className="text-xs text-taupe">/ sesión</span>
                  </p>
                  <button
                    onClick={() => onBook(s.name)}
                    data-testid={`service-book-btn-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="inline-flex items-center gap-1.5 rounded-full border border-gold text-gold hover:bg-gold hover:text-white text-xs font-medium px-4 py-2 transition-colors duration-200"
                  >
                    <CalendarDays className="w-3.5 h-3.5" />
                    Reservar
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
